<template>
    <div id="container">
        <v-container>
            <v-layout
                    wrap
            >
                <v-flex xs12 :pa-5="!$vuetify.breakpoint.smAndDown" :pa-2="$vuetify.breakpoint.smAndDown">
                    <h1 class="text-xs-center mb-3">FESTNETZ UND DSL OHNE SCHUFA-PRÜFUNG</h1>
                    <p class="headline">{{ text }}</p>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
  export default {
    data: () => ({
      text: 'Ist ein negativer Schufa-Eintrag dafür verantwortlich, dass Ihnen eine schnelle Internetverbindung vom Anbieter Ihrer Wahl verweigert wird, sind die Experten von easyphones zur Stelle. Wir vermitteln Ihnen attraktive DSL-Angebote ohne Schufa-Prüfung! Schwebt Ihnen zudem eine leistungsstarke Festnetz-Flatrate vor, haben Sie bei uns die Möglichkeit, Ihre Wünsche zu erfüllen. Machen Sie sich zunächst ein eigenes Bild von den schufafreien Festnetz- und DSL-Angeboten auf unserer Website und vergleichen Sie die Angebote von sämtlichen Top-Anbietern.'
    })
  }
</script>

<style lang="scss" scoped>
    #container {
        background: rgb(122,188,255);
        background: -moz-linear-gradient(left, rgba(122,188,255,1) 0%, rgba(170,212,255,1) 100%);
        background: -webkit-linear-gradient(left, rgba(122,188,255,1) 0%,rgba(170,212,255,1) 100%);
        background: linear-gradient(to right, rgba(122,188,255,1) 0%,rgba(170,212,255,1) 100%);
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#7abcff', endColorstr='#aad4ff',GradientType=1 );
    }
</style>
